import { useMutation } from '@tanstack/react-query';
import getFetchWrapper from '../helpers/getFetchWrapperWithTrackingId';
import { settlementQuestionnaireUrl } from '../const/api-endpoints';
import { HttpMethod } from '../const/http-method';
import { useMainContext } from '../context';
export var getSubmitSettlementQuestionnaireCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType;
    return [settlementQuestionnaireUrl, { accountId: accountId, accountIdType: accountIdType }];
};
var useSubmitSettlementQuestionnaire = function (questionAndAnswer) {
    var _a = useMainContext(), accountId = _a.accountId, accountIdType = _a.accountIdType, config = _a.config;
    var fetchWrapper = getFetchWrapper(config, accountId);
    return useMutation({
        mutationKey: getSubmitSettlementQuestionnaireCacheKey({
            accountId: accountId,
            accountIdType: accountIdType
        }),
        mutationFn: function () {
            return fetchWrapper(settlementQuestionnaireUrl, {
                body: JSON.stringify({
                    'cipher.accountId': accountId,
                    accountIdType: accountIdType,
                    questionAndAnswer: questionAndAnswer
                }),
                method: HttpMethod.POST
            });
        },
        onError: function (err) {
            // Throw error so response can be handled
            throw err;
        }
    });
};
export default useSubmitSettlementQuestionnaire;
//# sourceMappingURL=use-submit-settlement-questionnaire.js.map